/**
 * Hide SparkLayer sections for company owners
 * This script hides both orders and reports sections in French and English:
 * - French: "Mes dernières commandes" (recent orders) and "Mes analyses de données" (data analysis)
 * - English: "Recent Activity" (recent orders) and "Reports" (data analysis)
 * 
 * Company owner detection works by checking:
 * 1. parentAccount has data (object with company details)
 * 2. role is NOT 'limited-customer'
 * 
 * Only employees (parentAccount: null OR role == 'limited-customer') should see these sections
 * Company owners (parentAccount: object with company details AND role != 'limited-customer') will have these sections hidden
 */
(function() {
  'use strict';

  function hideSectionsForCompanyOwners() {
    try {
      // Get SparkLayer data from localStorage
      const sparkLayerData = localStorage.getItem('sparkLayerData');
      if (!sparkLayerData) {
        console.log('SparkLayer: No user data found in localStorage');
        return false;
      }

      const data = JSON.parse(sparkLayerData);
      console.log('SparkLayer: Full data loaded', data);
      
      // Handle both old and new data structures
      const userData = data.userData || data;
      console.log('SparkLayer: User data:', userData);
      console.log('SparkLayer: parentAccount value:', userData.parentAccount);
      console.log('SparkLayer: parentAccount type:', typeof userData.parentAccount);
      console.log('SparkLayer: role:', userData.role);
      console.log('SparkLayer: Is null?', userData.parentAccount === null);
      console.log('SparkLayer: Is undefined?', userData.parentAccount === undefined);
      console.log('SparkLayer: Is object?', typeof userData.parentAccount === 'object' && userData.parentAccount !== null);
      console.log('SparkLayer: Is limited-customer?', userData.role === 'limited-customer');

      // Check if user is a company owner (parentAccount has data AND role is not 'limited-customer')
      // Employee: parentAccount is null/undefined/empty OR role is 'limited-customer'  
      // Owner: parentAccount is an object with company details AND role is not 'limited-customer'
      const isCompanyOwner = (userData.parentAccount && 
                             userData.parentAccount !== null && 
                             userData.parentAccount !== undefined &&
                             typeof userData.parentAccount === 'object' && 
                             Object.keys(userData.parentAccount).length > 0) && 
                            userData.role !== 'limited-customer';
      
      if (isCompanyOwner) {
        console.log('SparkLayer: User is a company owner, hiding orders and data analysis sections');
        
        // Try multiple methods to find the SparkLayer content
        let shadowRoot = null;
        
        // Method 1: Find spark-drawer element
        const sparkDrawer = document.querySelector('spark-drawer');
        if (sparkDrawer && sparkDrawer.shadowRoot) {
          shadowRoot = sparkDrawer.shadowRoot;
          console.log('SparkLayer: Found shadow root via spark-drawer');
        }
        
        // Method 2: Try other SparkLayer elements
        if (!shadowRoot) {
          const sparkElements = document.querySelectorAll('[class*="spark"], [id*="spark"]');
          for (let element of sparkElements) {
            if (element.shadowRoot) {
              shadowRoot = element.shadowRoot;
              console.log('SparkLayer: Found shadow root via spark element:', element.tagName);
              break;
            }
          }
        }
        
        // Method 3: Try to find in regular DOM (not in shadow)
        if (!shadowRoot) {
          console.log('SparkLayer: No shadow root found, trying regular DOM');
          // Look directly in the document for the orders section
          const ordersSection = document.querySelector('section');
          const allSections = document.querySelectorAll('section');
          console.log('SparkLayer: Found', allSections.length, 'sections in regular DOM');
          
          let hiddenSections = 0;
          for (let section of allSections) {
            const text = section.textContent || '';
            // Check for orders section in both French and English
            if (text.includes('Mes dernières commandes') || text.includes('Recent Activity')) {
              console.log('SparkLayer: Found orders section in regular DOM');
              section.style.display = 'none';
              hiddenSections++;
            }
            // Check for data analysis section in both French and English
            if (text.includes('Mes analyses de données') || text.includes('Reports')) {
              console.log('SparkLayer: Found data analysis section in regular DOM');
              section.style.display = 'none';
              hiddenSections++;
            }
          }
          if (hiddenSections > 0) {
            return true;
          }
        }
        
        if (!shadowRoot) {
          console.log('SparkLayer: No shadow root or regular DOM orders section found');
          return false;
        }

        // Look for both orders and data analysis sections by their header text (multiple ways)
        let ordersSection = null;
        let dataAnalysisSection = null;
        
        // Method 1: Look for sections with h4 containing specific text
        const sections = Array.from(shadowRoot.querySelectorAll('section'));
        ordersSection = sections.find(section => {
          const header = section.querySelector('h4');
          return header && (header.textContent.includes('Mes dernières commandes') || header.textContent.includes('Recent Activity'));
        });
        
        dataAnalysisSection = sections.find(section => {
          const header = section.querySelector('h4');
          return header && (header.textContent.includes('Mes analyses de données') || header.textContent.includes('Reports'));
        });
        
        // Method 2: Look for sections with any header containing specific text
        if (!ordersSection) {
          ordersSection = sections.find(section => {
            const headers = section.querySelectorAll('h1, h2, h3, h4, h5, h6');
            return Array.from(headers).some(header => 
              header.textContent.includes('commandes') || 
              header.textContent.includes('orders') ||
              header.textContent.includes('dernières') ||
              header.textContent.includes('Recent Activity')
            );
          });
        }
        
        if (!dataAnalysisSection) {
          dataAnalysisSection = sections.find(section => {
            const headers = section.querySelectorAll('h1, h2, h3, h4, h5, h6');
            return Array.from(headers).some(header => 
              header.textContent.includes('analyses') || 
              header.textContent.includes('données') ||
              header.textContent.includes('data analysis') ||
              header.textContent.includes('rapports') ||
              header.textContent.includes('Reports')
            );
          });
        }
        
        // Method 3: Look for sections containing specific content
        if (!ordersSection) {
          ordersSection = sections.find(section => {
            const text = section.textContent || '';
            return text.includes('Mes dernières commandes') || 
                   text.includes('Recent Orders') ||
                   text.includes('Recent Activity') ||
                   (text.includes('commandes') && text.includes('dernières'));
          });
        }
        
        if (!dataAnalysisSection) {
          dataAnalysisSection = sections.find(section => {
            const text = section.textContent || '';
            return text.includes('Mes analyses de données') || 
                   text.includes('Data Analysis') ||
                   text.includes('Reports') ||
                   text.includes('Historique d\'achat') ||
                   (text.includes('analyses') && text.includes('données'));
          });
        }
        
        // Method 4: Look for any element containing the exact text
        if (!ordersSection || !dataAnalysisSection) {
          const allElements = shadowRoot.querySelectorAll('*');
          for (let element of allElements) {
            if (!ordersSection && element.textContent && 
                (element.textContent.includes('Mes dernières commandes') || element.textContent.includes('Recent Activity'))) {
              // Find the closest section parent
              ordersSection = element.closest('section');
              if (ordersSection) {
                console.log('SparkLayer: Found orders section via text search in shadow DOM');
              }
            }
            if (!dataAnalysisSection && element.textContent && 
                (element.textContent.includes('Mes analyses de données') || element.textContent.includes('Reports'))) {
              // Find the closest section parent
              dataAnalysisSection = element.closest('section');
              if (dataAnalysisSection) {
                console.log('SparkLayer: Found data analysis section via text search in shadow DOM');
              }
            }
            if (ordersSection && dataAnalysisSection) break;
          }
        }

        let hiddenSections = 0;
        
        if (ordersSection) {
          // Hide using multiple methods for maximum effectiveness
          ordersSection.style.display = 'none';
          ordersSection.style.visibility = 'hidden';
          ordersSection.style.opacity = '0';
          ordersSection.style.height = '0';
          ordersSection.style.overflow = 'hidden';
          ordersSection.setAttribute('hidden', 'true');
          console.log('SparkLayer: Orders section hidden successfully');
          hiddenSections++;
        }
        
        if (dataAnalysisSection) {
          // Hide using multiple methods for maximum effectiveness
          dataAnalysisSection.style.display = 'none';
          dataAnalysisSection.style.visibility = 'hidden';
          dataAnalysisSection.style.opacity = '0';
          dataAnalysisSection.style.height = '0';
          dataAnalysisSection.style.overflow = 'hidden';
          dataAnalysisSection.setAttribute('hidden', 'true');
          console.log('SparkLayer: Data analysis section hidden successfully');
          hiddenSections++;
        }
        
        if (hiddenSections > 0) {
          return true;
        } else {
          console.log('SparkLayer: No sections found to hide in shadow DOM');
          return false;
        }
      } else {
        console.log('SparkLayer: User is an employee (parentAccount is null or role is limited-customer), orders and data analysis sections should be visible');
        
        // Make sure both sections are visible for employees
        // Try to find and show the sections if they were previously hidden
        let shadowRoot = null;
        
        const sparkDrawer = document.querySelector('spark-drawer');
        if (sparkDrawer && sparkDrawer.shadowRoot) {
          shadowRoot = sparkDrawer.shadowRoot;
        }
        
        if (shadowRoot) {
          const sections = Array.from(shadowRoot.querySelectorAll('section'));
          
          const ordersSection = sections.find(section => {
            const text = section.textContent || '';
            return text.includes('Mes dernières commandes') || text.includes('Recent Activity');
          });
          
          const dataAnalysisSection = sections.find(section => {
            const text = section.textContent || '';
            return text.includes('Mes analyses de données') || text.includes('Reports');
          });
          
          if (ordersSection) {
            // Ensure orders section is visible for company owners
            ordersSection.style.display = '';
            ordersSection.style.visibility = '';
            ordersSection.style.opacity = '';
            ordersSection.style.height = '';
            ordersSection.style.overflow = '';
            ordersSection.removeAttribute('hidden');
            console.log('SparkLayer: Ensured orders section is visible for employee');
          }
          
          if (dataAnalysisSection) {
            // Ensure data analysis section is visible for employees
            dataAnalysisSection.style.display = '';
            dataAnalysisSection.style.visibility = '';
            dataAnalysisSection.style.opacity = '';
            dataAnalysisSection.style.height = '';
            dataAnalysisSection.style.overflow = '';
            dataAnalysisSection.removeAttribute('hidden');
            console.log('SparkLayer: Ensured data analysis section is visible for employee');
          }
        }
        
        // Also check regular DOM
        const allSections = document.querySelectorAll('section');
        for (let section of allSections) {
          const text = section.textContent || '';
          if (text.includes('Mes dernières commandes') || text.includes('Recent Activity')) {
            section.style.display = '';
            section.style.visibility = '';
            section.style.opacity = '';
            section.style.height = '';
            section.style.overflow = '';
            section.removeAttribute('hidden');
            console.log('SparkLayer: Ensured orders section is visible for employee (regular DOM)');
          }
          if (text.includes('Mes analyses de données') || text.includes('Reports')) {
            section.style.display = '';
            section.style.visibility = '';
            section.style.opacity = '';
            section.style.height = '';
            section.style.overflow = '';
            section.removeAttribute('hidden');
            console.log('SparkLayer: Ensured data analysis section is visible for employee (regular DOM)');
          }
        }
        
        return true;
      }
    } catch (error) {
      console.error('SparkLayer: Error hiding sections:', error);
      return false;
    }
  }

  // Retry mechanism with exponential backoff
  function attemptHideSections(attempt = 1, maxAttempts = 10) {
    const delay = Math.min(1000 * Math.pow(1.5, attempt - 1), 5000); // Max 5 seconds delay
    
    console.log(`SparkLayer: Attempt ${attempt}/${maxAttempts} to hide sections`);
    
    if (hideSectionsForCompanyOwners()) {
      console.log('SparkLayer: Successfully processed sections visibility');
      return;
    }

    if (attempt < maxAttempts) {
      setTimeout(() => {
        attemptHideSections(attempt + 1, maxAttempts);
      }, delay);
    } else {
      console.log('SparkLayer: Max attempts reached, giving up');
    }
  }

  // Start the process when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => attemptHideSections(), 100);
    });
  } else {
    setTimeout(() => attemptHideSections(), 100);
  }

  // Also observe for dynamic changes to the SparkLayer drawer
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasSparkDrawer = addedNodes.some(node => 
          node.nodeType === Node.ELEMENT_NODE && 
          (node.tagName === 'SPARK-DRAWER' || node.querySelector('spark-drawer'))
        );
        
        if (hasSparkDrawer) {
          console.log('SparkLayer: New spark-drawer detected, processing...');
          setTimeout(() => attemptHideSections(), 200);
        }
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Listen for clicks on "Mon compte" / "My Account" button
  document.addEventListener('click', function(event) {
    // Check for "Mon compte" or "My Account" button by title attribute
    const accountButton = event.target.closest('button[title="Mon compte"], button[title="My Account"]');
    if (accountButton) {
      console.log('SparkLayer: Account button clicked, running visibility check');
      // Run with delays to allow tab content to load
      setTimeout(() => attemptHideSections(1, 5), 200);
      setTimeout(() => attemptHideSections(1, 3), 500);
      setTimeout(() => attemptHideSections(1, 2), 1000);
      return;
    }

    // Also check for buttons containing "Mon compte" or "My Account" text
    const buttonWithAccountText = event.target.closest('button');
    if (buttonWithAccountText && (buttonWithAccountText.textContent.includes('Mon compte') || buttonWithAccountText.textContent.includes('My Account'))) {
      console.log('SparkLayer: Account button (by text) clicked, running visibility check');
      setTimeout(() => attemptHideSections(1, 5), 200);
      setTimeout(() => attemptHideSections(1, 3), 500);
      setTimeout(() => attemptHideSections(1, 2), 1000);
      return;
    }

    // General SparkLayer interaction handler
    const sparkElement = event.target.closest('[class*="spark"], spark-drawer');
    if (sparkElement) {
      // Run a quick check for any SparkLayer interactions
      setTimeout(() => attemptHideSections(1, 3), 100);
    }
  });

  // Cleanup observer after 30 seconds to prevent memory leaks
  setTimeout(() => {
    observer.disconnect();
    console.log('SparkLayer: Observer disconnected');
  }, 30000);

})();
